import { Position, StateObj } from 'src/types'
import { positionChecker } from 'src/logic'
import {
  onEdgeTojiCenter,
  onEdgeTojiCenter2,
  onEdgeTojiLittle,
  onEdgeTojiLittle2,
  onEdgeTojiLittle3,
  onEdgeTojiLittle4,
  onEdgeTojiThumb,
  onEdgeTojiThumb1
} from './lace/onEdgeToji'

export const edges = (
  ctx: CanvasRenderingContext2D,
  edgeColor: string,
  laceColor: string,
  stitchColor: string,
  position: Position,
  bankLaceDirection: StateObj
): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = edgeColor

  // ヘリ革
  ctx.beginPath()
  ctx.moveTo(278, 487) //
  ctx.quadraticCurveTo(262, 486, 263, 468) //
  ctx.quadraticCurveTo(266, 458, 282, 454) //
  ctx.quadraticCurveTo(294, 451, 299, 467) // // 左上円部分＿内側
  ctx.quadraticCurveTo(318, 524, 358, 548) // // 左上円部分
  ctx.quadraticCurveTo(417, 570, 507, 568) // //
  ctx.quadraticCurveTo(544, 568, 575, 550) // //
  ctx.quadraticCurveTo(611, 523, 635, 441) // //
  ctx.quadraticCurveTo(638, 423, 652, 430) // 小指側＿頂点
  ctx.quadraticCurveTo(670, 445, 655, 462) //
  ctx.quadraticCurveTo(647, 519, 614, 555) //
  ctx.quadraticCurveTo(560, 600, 495, 581) //
  ctx.quadraticCurveTo(395, 585, 339, 558) //
  ctx.quadraticCurveTo(340, 583, 328, 587) //
  ctx.quadraticCurveTo(317, 588, 318, 580) //
  ctx.quadraticCurveTo(325, 575, 322, 562) //
  ctx.quadraticCurveTo(290, 535, 277, 488) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 左側＿つなぎ目の線
  ctx.beginPath()
  ctx.moveTo(274, 470) //
  ctx.quadraticCurveTo(283, 474, 286, 467) //
  ctx.quadraticCurveTo(302, 525, 340, 560) //
  ctx.stroke()
  ctx.closePath()

  // 右側＿つなぎ目の線
  ctx.beginPath()
  ctx.moveTo(643, 446) //
  ctx.quadraticCurveTo(645, 450, 649, 448) //
  ctx.quadraticCurveTo(617, 588, 497, 582) //
  ctx.stroke()
  ctx.closePath()

  // 左下
  ctx.beginPath()
  ctx.moveTo(320, 587) // 左下
  ctx.quadraticCurveTo(364, 591, 395, 576) // 右下
  ctx.quadraticCurveTo(373, 572, 373, 572) // 右上
  ctx.quadraticCurveTo(350, 577, 339, 571) // 左上
  ctx.quadraticCurveTo(338, 585, 320, 587) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath() // 土手紐＿ヘリ革周り

  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])

  // 土手親指〜小指
  ctx.moveTo(262, 472) // 親指外
  ctx.quadraticCurveTo(261, 459, 273, 456)
  ctx.quadraticCurveTo(288, 445, 296, 460)
  ctx.quadraticCurveTo(304, 470, 309, 494)
  ctx.quadraticCurveTo(325, 530, 358, 548)
  ctx.quadraticCurveTo(405, 567, 466, 566)
  ctx.quadraticCurveTo(517, 573, 572, 553)
  ctx.quadraticCurveTo(595, 532, 608, 507)
  ctx.quadraticCurveTo(635, 444, 631, 444) //小指内
  ctx.moveTo(649, 427) // 小指外
  ctx.quadraticCurveTo(673, 438, 657, 459)
  ctx.quadraticCurveTo(647, 498, 637, 520)

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  bankLaceAroundEdge(ctx, position, laceColor, bankLaceDirection)
}

const bankLaceAroundEdge = (ctx: CanvasRenderingContext2D, position: Position, color: string, bankLaceDirection: StateObj): void => {
  const isDefault = ['unselected', undefined].includes(bankLaceDirection?.value)
  const { isPitcher } = positionChecker(position)
  // 逆巻き
  if (bankLaceDirection?.value === 'reverseRoll' || (isDefault && !isPitcher)) {
    onEdgeTojiThumb(ctx, color, 0, 0) // 親指側＿根元側
    onEdgeTojiThumb(ctx, color, -22, -25)
    onEdgeTojiThumb(ctx, color, 115, -180, 20) // 親指側＿先端
    onEdgeTojiThumb(ctx, color, 165, -265, 30)
    onEdgeTojiCenter(ctx, color, 0, 2)
    onEdgeTojiCenter(ctx, color, -65, 74, -10)
    onEdgeTojiCenter(ctx, color, -35, 81, -10)
    onEdgeTojiCenter(ctx, color, 7, 90, -10)
    onEdgeTojiCenter(ctx, color, -45, 155, -18)
    onEdgeTojiCenter(ctx, color, -12, 157, -18)
    onEdgeTojiCenter(ctx, color, -410, 255, -50)
    onEdgeTojiLittle(ctx, color, 0, 0)
    onEdgeTojiLittle(ctx, color, -83, 75, -10)
    onEdgeTojiLittle2(ctx, color)
    onEdgeTojiLittle(ctx, color, -65, 50, -10)
  }
  // 順巻き
  if (bankLaceDirection?.value === 'sequentialRoll' || (isDefault && isPitcher)) {
    onEdgeTojiThumb1(ctx, color, -14, -30) // 親指2
    onEdgeTojiThumb(ctx, color, 160, -270, 30) // 親指1
    onEdgeTojiThumb1(ctx, color, -4, -9)
    onEdgeTojiThumb1(ctx, color, -145, 50, -15, 1.05)
    onEdgeTojiCenter2(ctx, color, -49, -10, 0) //
    onEdgeTojiCenter2(ctx, color, -5, -2, 0) //
    onEdgeTojiCenter2(ctx, color, -65, 70, -10) //
    onEdgeTojiCenter2(ctx, color, -135, 135, -20) //
    onEdgeTojiCenter2(ctx, color, -87, 152, -20) //
    onEdgeTojiLittle4(ctx, color, -80, 73, -10)
    onEdgeTojiLittle4(ctx, color, 0, 0)
    onEdgeTojiLittle3(ctx, color, -23, 32)
    onEdgeTojiLittle3(ctx, color, 108, -180, 20)
    onEdgeTojiLittle2(ctx, color) // 小指1
    onEdgeTojiLittle4(ctx, color, -70, 53, -10)
  }
}
